import script from "./CourseRerunRoundsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseRerunRoundsTab.vue?vue&type=script&setup=true&lang=js"

import "./CourseRerunRoundsTab.vue?vue&type=style&index=0&id=3d248714&lang=css"

const __exports__ = script;

export default __exports__